import Content from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/parts/Content'
import { EditAutomaticContainersModalProps } from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/types'
import Modal from '@/features/ui/components/Modal'
import { FC } from 'react'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const EditAutomaticContainersModal: FC<EditAutomaticContainersModalProps> = ({
    activeContainers,
    containersToRemove,
    layout,
    onStageRemoval,
    onRestore,
    onCancel,
    onConfirm,
}) => {
    const { styles } = useStyles(stylesheet, { layout })

    return (
        <Modal
            contentVariant="wide"
            backdropStyle={styles.modalBackdrop}
            contentStyle={styles.modalContent}
        >
            <Content
                activeContainers={activeContainers}
                containersToRemove={containersToRemove}
                onStageRemoval={onStageRemoval}
                onRestore={onRestore}
                onCancel={onCancel}
                onConfirm={onConfirm}
            />
        </Modal>
    )
}

const stylesheet = createStyleSheet((_, { insets }) => ({
    modalBackdrop: {
        variants: {
            layout: {
                compact: {},
                extended: {
                    paddingVertical: 32,
                    paddingBottom: 32 + insets.bottom,
                },
            },
        },
    },
    modalContent: {
        height: '100%',
        overflow: 'hidden',
        variants: {
            layout: {
                compact: {},
                extended: {
                    width: '88%',
                },
            },
        },
    },
}))

export default EditAutomaticContainersModal
